import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "../../lib/api";

export default function JournalPost() {
  const { slug } = useParams();
  const [p, setP] = useState(null);
  useEffect(() => {
    api.get(`/journal/${slug}`).then((r) => setP(r.data));
  }, [slug]);

  if (!p) return <div className="min-h-[60vh] flex items-center justify-center text-white/40 tracking-luxury uppercase text-sm">Loading…</div>;

  return (
    <article data-testid="journal-post" className="bg-poche-black text-white">
      <header className="container-x py-16 max-w-3xl">
        <Link to="/journal" className="text-[11px] tracking-luxury uppercase text-poche-gold">← Journal</Link>
        <p className="text-[11px] tracking-luxury uppercase text-poche-gold mt-8">{p.category} · {p.date}</p>
        <h1 className="font-serif text-5xl md:text-6xl mt-3 leading-[1]">{p.title}</h1>
      </header>
      <div className="container-x">
        <div className="aspect-[16/8] overflow-hidden">
          <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
        </div>
      </div>
      <div className="container-x py-16 max-w-3xl">
        {p.body.map((para, i) => (
          <p key={i} className="text-white/75 leading-relaxed text-lg mt-6">{para}</p>
        ))}
        <div className="mt-12 border-t border-poche-gold/30 pt-8 text-[11px] tracking-luxury uppercase text-white/45">— Joseph Poche · House Editorial</div>
      </div>
    </article>
  );
}
